import { Component, Input, OnChanges } from '@angular/core';
import { ComponentData, TabData, TabUtil } from '@ddt-web/data-service';

@Component({
	selector: 'esg-holding-rankings-table',
	templateUrl: './esg-holding-rankings-table.component.html',
	styleUrls: ['./esg-holding-rankings-table.component.scss']
})
export class EsgHoldingRankingsTableComponent implements OnChanges {
	@Input() public data: ComponentData;
	@Input() public tabs: TabData[] = [];
	@Input() public tableIndex: number = 0;
	public excludeColumns: string[] = [];
	public columnWidths: number[] = [];
	public isValidTableData: boolean = false;

	@Input() private singlePortColumnProportions: number[] = [10, 43, 15, 13, 9, 10];
	@Input() private multiPortColumnProportions: number[] = [10, 32, 15, 10, 13, 10, 10];

	public ngOnChanges(): void {
		this.isValidTableData = this.tabs.every(tab => !TabUtil.isEmptyTable(tab?.tableData[this.tableIndex]));
		// don't show the portfolio column when only 1 portfolio is selected
		if (this.data?.portfolioData) {
			this.excludeColumns = this.data.portfolioData.length > 1 ? [] : ['portfolio'];
			this.columnWidths = this.data.portfolioData.length > 1 ? this.multiPortColumnProportions : this.singlePortColumnProportions;
		}
	}
}
